<template>
  <page-outline :title="listTitle">
    <template slot="pageContent">
      <div class="listPage ml-3 mr-3">
        <!-- Bouton de rafraîchissement -->
        <b-row class="justify-content-start">
          <b-col cols="4" lg="2" xl="1" class="mb-5">
            <b-button class="btn btnFilter" :disabled="activateSpinner" @click="onRefresh">
              <i class="fa-light fa-rotate-right fs-14px"></i>
            {{ $t('common.rfrsh') }}
            </b-button>
          </b-col>
        </b-row>

        <b-row class="justify-content-center mb-5">
          <div>
            <spinner v-if="activateSpinner"></spinner>
            <b-table v-else-if="listItems.length > 0"
              :items="listItems"
              :fields="fields"
              :sort-by.sync="sortBy"
              class="table-striped"
              fixed
              hover
              :selectable="listItems.length > 0"
              :empty-text="$t('common.security.no_result')"
              @row-selected="seeRemoteFolderDetails"
              :key="refreshKey">
              <template #cell(Name)="data">
                <span>{{ data.value }}</span>
              </template>
              <template #cell(Path)="data">
                <span>{{ data.value }}</span>
              </template>
              <template #cell(edit)="data">
                <span class="text-center d-inline-block py-3 w-100" @click="actionEdit($event, data.value)">
                  <i class="fa-regular fa-pencil"></i>
                </span>
              </template>
              <template #cell(delete)="data">
                <span class="text-center d-inline-block py-3 w-100" @click="actionDelete($event, data.value)">
                  <i class="fa-regular fa-trash"></i>
                </span>
              </template>
            </b-table>
            <div v-else class="d-flex justify-content-center">
              <span class="noResult">
                {{ $t('common.no_result') }}
              </span>
            </div>
          </div>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import Spinner from '@/components/common/spinner.vue'
import { errorMessageAlert } from '@/helpers/alert'
import { loadPage } from '@/helpers/routing'

export default {
  name: 'RemoteFolderConfigurationPage',
  components: {
  'form-write-group-label-input':formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: {
    id: {
      type: String,
      default: '-1'
    }
  },
  data () {
    return {
      activateSpinner: false,
      listTitle: '',
      refreshKey: false,
      listItems: [],
      elementSearchedRemoteFolderConfig: '',
      sortBy: 'Name'
    }
  },
  computed: {
    canAdd () {
      return true
    },
    canEdit () {
      return true
    },
    canDelete () {
      return true
    },
    fields () {
      let fields = []

      fields.push({
        key: 'Name',
        label: this.$t('common.routing.config_name'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      fields.push({
        key: 'Path',
        label: this.$t('common.routing.path'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      // if (this.canEdit) {
      //   fields.push({ key: 'edit', label: this.$t('rights.edit'), thClass: 'text-center table-condensed-ipad w-10', tdClass: 'p-0' })
      // }
      return fields
    }
  },
  created () {
    this.listTitle = this.$i18n.t('Webheader.remoteFolderConfig_consult')
    this.activateSpinner = true
    this.getRemoteFolderConfig()

    if (this.id !== '-1') {
      this.tabName = parseInt(this.id)
    }
  },
  methods: {
    actionDelete ($e, id) {
      $e.stopPropagation()
      let that = this
      this.$f7.modal({
        title: this.$t('common.security.element_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = { id: id }
              that.$engine.firstOn().routing.config.remoteFolder.delete(params)
              .then(resp => {
                that.$f7.modal({
                  title: that.$t('common.security.remotefolder_config_deleted'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                loadPage(that, { url: '/routing/remoteFolderConfig/-1' })
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('common.security.cert_delete_error'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () { return }
          }
        ]
      })
    },
    // actionEdit ($e, id) {
    //   loadPage(this, { url: '/routing/interProcessConfig/edit/' + id })
    // },
    applyFilters (typeList) {
      this.activateSpinner = true
      this.getRemoteFolderConfig()
    },
    emptyFilters (typeList) {
      this.activateSpinner = true
      this.getRemoteFolderConfig()
    },
    getRemoteFolderConfig () {
      let that = this
      let params = { name: this.elementSearchedRemoteFolderConfig }
      this.$engine.firstOn().routing.config.remoteFolder.fetch(params)
      .then(resp => {
        let remoteFolderConfigList = {}

        remoteFolderConfigList = resp.data.RemoteFolder
        for (let i = 0; i < remoteFolderConfigList.length; i++) {
          remoteFolderConfigList[i].delete = remoteFolderConfigList[i].id
          remoteFolderConfigList[i].edit = remoteFolderConfigList[i].id
        }
        that.updateRemoteFolderConfig(remoteFolderConfigList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    onRefresh () {
      this.refreshKey = !this.refreshKey;
      this.activateSpinner = true;
      this.getRemoteFolderConfig();
    },
    seeRemoteFolderDetails (items) {
      let config = items[0]
      let that = this

      this.$engine.firstOn().routing.config.clickedConfig = config
      loadPage(that, {url: '/routing/remoteFolderConfigurationDetails/details'})
    },
    updateRemoteFolderConfig (remoteFolderConfigList) {
      this.listItems = remoteFolderConfigList
    }
  }
}
</script>
